import { GroupRowDto } from '@core/typings/group-row.type';
import { PeriodUsageDto } from '@services/dtos/rows/period-usage.dto';
import { AssignmentGroupDefinition } from '@services/models/group-definition.model';
import { PlanningBoardGroupRowType } from '@shared/components/grids/rows/groups/planning-board-group-row-type.enum';
import { PlanningRow } from '../planning-row';

/**
 * Represents a basic group row in the planning board.
 * Abstract : Every group row class extends this class.
 */
export abstract class PlanningGroupRow extends PlanningRow {
  public abstract type: PlanningBoardGroupRowType;
  public label: string = '';
  public expandAll: boolean = false;

  public constructor(
    public dto: GroupRowDto,
    public projectId?: string,
    public departmentId?: string,
    public classId?: string,
    public resourceId?: string
  ) {
    super(projectId, departmentId, classId, resourceId, !resourceId); // Since we are talking about group, if no resourceId is provided, we should ignore it. While an assignment could have it undefined.
  }

  public abstract toGroupDefinition(): AssignmentGroupDefinition;

  public override getValueOrDefault(periodId: number): PeriodUsageDto {
    return this.dto.periodUsage.find(u => u.periodId === periodId) ?? { periodId, plannedHours: 0 };
  }

  public override setValue(value: PeriodUsageDto) {
    this.dto.periodUsage = [...this.dto.periodUsage.filter(ap => ap.periodId !== value.periodId), value];
    this.dto.periodUsage.sort((a, b) => a.periodId - b.periodId);
  }
}
